export default __webpack_public_path__ + "static/ab-sketches-a6d300425481f0ea56c7c47f85f2c020.jpg";